"use client";

import { Tooltip as BaseTooltip, TooltipTrigger as BaseTooltipTrigger } from "design-system/tooltip";
import type { ComponentProps } from "react";
import { useRef } from "react";

import { type DispatchAgoraEventProps, dispatchAgoraEvent } from "@/lib/utils/dispatch-agora-event";

export { TooltipContent, TooltipProvider } from "design-system/tooltip";

interface TooltipProps extends ComponentProps<typeof BaseTooltip> {
  eventProps?: Partial<DispatchAgoraEventProps>;
}

function Tooltip({ eventProps, children, ...props }: TooltipProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  function handleOpenChange(open: boolean) {
    // Find the trigger element within the wrapper to get its text
    const elementText = containerRef.current?.querySelector<HTMLElement>('[data-slot="tooltip-trigger"]')?.textContent;
    dispatchAgoraEvent({
      eventType: "product.hovered",
      eventLocation: "body",
      eventAction: open ? "tooltip.opened" : "tooltip.closed",
      elementText: elementText ?? undefined,
      ...eventProps,
    });
  }

  return (
    <BaseTooltip onOpenChange={handleOpenChange} {...props}>
      <div ref={containerRef}>{children}</div>
    </BaseTooltip>
  );
}

interface TooltipTriggerProps extends ComponentProps<typeof BaseTooltipTrigger> {
  eventProps?: Partial<DispatchAgoraEventProps>;
}

function TooltipTrigger({ eventProps: _eventProps, ...props }: TooltipTriggerProps) {
  return <BaseTooltipTrigger {...props} />;
}

export { Tooltip, TooltipTrigger };
